import { render, staticRenderFns } from "./DetailTBM.vue?vue&type=template&id=1f6c095c&"
import script from "./DetailTBM.vue?vue&type=script&lang=js&"
export * from "./DetailTBM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports